import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { fadeInOutHeight } from '@app/animations/fade-in-out.animation';
import { ModalProvider } from '@app/components/_shared/modal/modal.component';
import { ResendActivationModel } from '@app/models/auth/resendActivation.model';
import { ResendActivationResponse } from '@app/models/auth/resendActivationResponse.model';
import { AuthService } from '@app/services/auth.service';
import { LocalisationService } from '@app/services/localisation.service';
import { AppConfig } from 'app/app.config';

import { ActivationComponent } from '../activation/activation.component';

@Component({
  selector: 'app-resend-activation',
  templateUrl: './resend-activation.component.html',
  styleUrls: ['./resend-activation.component.scss'],
  animations: [fadeInOutHeight]
})
export class ResendActivationComponent implements OnInit {
  static route: string = 'resend-activation';

  resendActivationForm: FormGroup;
  forgottenPasswordSubmitted: boolean = false;

  locale: any = {};
  public formSubmitted: boolean = false;

  constructor(
    private router: Router,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    public modal: ModalProvider,
    public localisation: LocalisationService
  ) {}

  ngOnInit() {
    this.locale = this.localisation.getTranslationsForComponent('ResendActivationComponent');

    this.resendActivationForm = this.formBuilder.group({
      email: [null, [Validators.required, Validators.pattern(AppConfig.emailRegex)]],
      url: [
        `${window.location.origin}/${ActivationComponent.route}${ActivationComponent.routeParams}`,
        Validators.required
      ]
    });
  }

  setFormSubmitted(value) {
    this.formSubmitted = value;
  }

  resendActivation(model: ResendActivationModel) {
    var showModal = false;

    this.forgottenPasswordSubmitted = true;

    if (!this.resendActivationForm.valid) {
      return;
    }
    this.setFormSubmitted(true);
    this.authService
      .resendActivation(model)
      .finally(() => {
        if (showModal) {
          this.modal
            .create(this.locale.confirmationModalTitle, this.locale.confirmationModalMessage)
            .then(ok => {
              this.router.navigate(['/login']);
            });
        }
        this.setFormSubmitted(false);
      })
      .subscribe(
        succeeded => {
          showModal = true;
        },
        (err: ResendActivationResponse) => {
          showModal = true;
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/account/resend-activation/resend-activation.component.ts